<template>
  <div>
    <!-- 新增账号 -->
    <el-dialog title="update password" center 
      :visible.sync="showModal" 
      style="width:70%;margin:0 auto;min-width: 900px"
      :modal='false'>
      <div class="block popup">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="form" label-width="150px" class="demo-ruleForm">
          <el-form-item label="old password" prop="pass">
            <el-input v-model="ruleForm.pass" maxlength="16" placeholder="please old password"></el-input>
          </el-form-item>
          <el-form-item label="new password" prop="newPass">
            <el-input v-model="ruleForm.newPass" maxlength="16" placeholder="please new password"></el-input>
          </el-form-item>
          <el-form-item label="confirm password" prop="checkPass">
            <el-input v-model="ruleForm.checkPass" maxlength="16" placeholder="confirm password"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style=" background-color: #ccc;
    border-color: #ccc; width:120px;
    border-radius: 20px;
    box-shadow: none;
    color: #fff ;
    text-align: center;" class="btn topBtn cancel" @click="showModal=false">Cancel</el-button>

        <el-button @click="submitForm('ruleForm'),showModal == false" style="width:120px;text-align:center"
          class="search-btn" type="primary">Confirm</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
  import {
    updatePassword
  } from '@/services/user'

  export default {
    name: 'index',
    data() {
      let regPass = /[0-9a-zA-Z]{4,20}/
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input old password'))
        } else if (regPass.test(value) == false) {

          callback(new Error('The first character of theassword cannot be a special character'))
        } else if(value.length < 8) {
          callback(new Error('The password must be at least 8 digits'))
        } else {
          callback()
        }
      }
      var validatePass1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input new password'))
        } else if (regPass.test(value) == false) {

          callback(new Error('The first character of theassword cannot be a special character'))
        } else {

          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input confirm password'))
        } else if (value !== this.ruleForm.newPass) {
          callback(new Error('Entered passwords differ'))
        } else {
          callback()
        }
      }
      return {
        showModal: false,
        ruleForm: {
          pass: '',
          newPass: '',
          checkPass: ''
        },
        rules: {
          pass: [{
            required: true,
            trigger: 'blur',
            validator: validatePass
          }],
          newPass: [{
            required: true,
            trigger: 'blur',
            validator: validatePass1
          }],
          checkPass: [{
            required: true,
            trigger: 'blur',
            validator: validatePass2
          }]
        }
      }
    },
    methods: {
      show() {
        this.resetForm();
        this.showModal = true
      },

      submitForm() {

        this.$refs.form.validate(async valid => {
          if (!valid) {
            return
          }
          let data = {
            oldPwd: this.ruleForm.pass, //唯一标识符，让其知道是在修改这条数据
            newPwd: this.ruleForm.newPass
          }
          if (this.ruleForm.newPass != this.ruleForm.checkPass) {
            this.$message({
              message: 'Entered passwords differ',
              type: 'error',
              showClose: true,
              duration: 2000
            });
            return
          }
          let red = /^[0-9a-zA-z].*/
          if (red.test(this.ruleForm.newPass) == false) {
            this.$message({
              message: 'Begin with a number or an English letter',
              type: 'error',
              showClose: true,
              duration: 2000
            });
            return
          }
          if (this.ruleForm.newPass.length < 8 || this.ruleForm.checkPass.length < 8) {
            this.$message({
              message: 'The entered password is invalid',
              type: 'error',
              showClose: true,
              duration: 2000
            });
            return
          }

          const response = await updatePassword({
            password: this.ruleForm.newPass,
            oldpassword: this.ruleForm.pass
          })
          if (response == "") {
            this.$message({
              message: 'Password updated successfully',
              type: 'success',
              showClose: true,
              duration: 2000
            })
            this.showModal = false
          } else if (response && response.status == 400) {
            this.$message({
              message: response.message,
              type: 'error',
              showClose: true,
              duration: 2000
            })
          } else {
            this.$message({
              message: 'Password update failed',
              type: 'error',
              showClose: true,
              duration: 2000
            })
          }

        })

      },
      resetForm() {
        if (this.$refs.form) {
          this.$refs.form.resetFields();
        }

      }
    }
  }
</script>

<style scoped>
  .search-btn {
    background-color: #004a98 !important;
    border-color: #004a98 !important;
    border-radius: 20px;
    box-shadow: none;
    color: #fff !important;
    /* height: 34px; */
    text-align: center;

  }
</style>
